export const API_URL = "https://qwtoolsapi.azurewebsites.net/"; // PROD
//export const API_URL = "https://localhost:7213/"; // Local

export const CLIENT_VERSION = "Version Beta 0.108 2025-12-11"; //Denna måste stämma överens med klientversionen i servern (Constants.ClientVersion)!!
